import React from 'react';
import PropTypes from 'prop-types';

// Components
import ListCard from '../../../components/ListCard';

// Constants
import { T, FONT_MONO, INDICATOR } from '../../../constants/tokens';
import { statusOf, describe, formatQuality, formatSeen, qualityFill, qualityText } from '../../network/format';

/**
 * A gateway or anchor on the Devices screen.
 *
 * Gateways lead with whether they are reachable; anchors with how good their
 * link is and where it goes, which is what the design puts in each.
 */
export default function NetworkNodeListCard({ node, onClick, selectedCardObject }) {
  const status = statusOf(node);
  const gateway = node.isGateway();
  const off = node.getIsConnected() === false;
  const statusColor = gateway || off ? status.dot : qualityFill(node.getNextHopQuality());
  const hops = node.getHopCount();

  const meta = gateway
    ? 'Last seen ' + formatSeen(node)
    : 'Next hop ' + (node.getNextHop() ?? '—') + (hops == null ? '' : ' · ' + hops + (hops === 1 ? ' hop' : ' hops'));

  const pill = gateway || off || node.getNextHopQuality() == null ? status.label : formatQuality(node);
  const pillInk = gateway || off ? status.text : qualityText(node.getNextHopQuality());

  return (
    <ListCard
      statusColor={statusColor}
      onClick={onClick}
      isSelected={selectedCardObject?.getNodeAddress?.() === node.getNodeAddress()}
      selectedColor={statusColor}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span
          aria-hidden='true'
          style={{
            width: 32,
            height: 32,
            flex: 'none',
            borderRadius: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: FONT_MONO,
            fontSize: 11,
            fontWeight: 500,
            background: gateway ? T.ink : T.surfaceSoft,
            color: gateway ? T.canvas : T.ink
          }}
        >
          {node.getRoleLabel()}
        </span>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontFamily: FONT_MONO, fontSize: 14, fontWeight: 500, lineHeight: '20px', color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {node.getNodeAddress()}
          </div>
          <div style={{ fontFamily: FONT_MONO, fontSize: 12, fontWeight: 500, lineHeight: '16px', textTransform: 'uppercase', color: T.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {describe(node)}
          </div>
          <div style={{ fontFamily: FONT_MONO, fontSize: 12, lineHeight: '16px', color: T.body, marginTop: 2 }}>
            {meta}
          </div>
        </div>

        <span
          style={{
            flex: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            background: T.hairlineSoft,
            borderRadius: 9999,
            padding: '4px 12px',
            fontFamily: FONT_MONO,
            fontSize: 12,
            fontWeight: 500,
            color: pillInk
          }}
        >
          <span style={{ width: 7, height: 7, borderRadius: 9999, background: off ? INDICATOR.error : statusColor }} />
          {pill}
        </span>
      </div>
    </ListCard>
  );
}

NetworkNodeListCard.propTypes = {
  node: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  selectedCardObject: PropTypes.object
};
